import { PractitionerSpecialty } from "../pbm/practitioner-management/practitioner-specialty";
import { IAutoCompleteItem } from "./iauto-complete-item";

export class PractitionerSpecialtyAutoCompleteItem implements IAutoCompleteItem {
  constructor(private practitionerSpecialty: PractitionerSpecialty) {}

  getPractitionerSpecialty(): PractitionerSpecialty {
    return this.practitionerSpecialty;
  }

  getDisplayValue(): string {
    return this.practitionerSpecialty.getDescription();
  }

  getKey(): string {
    return this.getPractitionerSpecialty().getKey();
  }
}
